const ActDaKa = [
  {
    path: "/d",
    component: (resolve) => require(["@/actscrm/meeting.vue"], resolve),
    children: [
      {
        path: "feifa",
        name: "dakafeifameeting",
        component: (resolve) => require(["@/actdaka/noerr.vue"], resolve),
        meta: {
          title: "电源网非法登录",
        },
      },
      {
        path: "l/:meetingid/:platid",
        name: "dakalgmeeting",
        component: (resolve) => require(["@/actdaka/login.vue"], resolve),
        meta: {
          title: "电源网登录",
        },
      },
      // 微信授权
      {
        path: "b/:meetingid/:platid/:type",
        name: "dakameeting",
        component: (resolve) => require(["@/actdaka/index.vue"], resolve),
        meta: {
          title: "电源网微信登录",
        },
      },
      // 扫码
      {
        path: "s/:meetingid/:platid/:type",
        name: "dakameetingsm",
        component: (resolve) => require(["@/actdaka/saoma.vue"], resolve),
        meta: {
          title: "展台扫码",
        },
      },
      // 会议介绍
      {
        path: "j/:meetingid",
        name: "dakameetingjs",
        component: (resolve) => require(["@/actdaka/jieshao.vue"], resolve),
        meta: {
          title: "会议介绍",
        },
      },
      // 展台介绍
      {
        path: "z/:meetingid",
        name: "dakameetingzt",
        component: (resolve) => require(["@/actdaka/zhantai.vue"], resolve),
        meta: {
          title: "展台介绍",
        },
      },
      // 选择奖品
      {
        path: "c/:meetingid",
        name: "dakameetingcs",
        component: (resolve) => require(["@/actdaka/chooseprize.vue"], resolve),
        meta: {
          title: "选择奖品",
        },
      },
      // 兑换码页面
      {
        path: "d/:meetingid",
        name: "dakameetingdh",
        component: (resolve) => require(["@/actdaka/duihuan.vue"], resolve),
        meta: {
          title: "兑换奖品",
        },
      },
    ],
  },
  // 已领取页面
  {
    path: "/daka",
    component: (resolve) => require(["@/actscrm/meeting.vue"], resolve),
    children: [
      {
        path: "lq/:meetingid/:code",
        name: "dakameetinglq",
        component: (resolve) => require(["@/actdaka/lingqu.vue"], resolve),
        meta: {
          title: "奖品领取",
        },
      },
      // 后台查询
      {
        path: "chaxun/:meetingid/",
        name: "dakameetingcx",
        component: (resolve) => require(["@/actdaka/chaxun.vue"], resolve),
        meta: {
          title: "奖品查询",
        },
      },
    ],
  },
];

export default ActDaKa;
